"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketControlStatus = exports.Roles = exports.FeeType = exports.KycLevel = void 0;
var KycLevel;
(function (KycLevel) {
    KycLevel[KycLevel["None"] = 1] = "None";
    KycLevel[KycLevel["TicketHolderInfo"] = 2] = "TicketHolderInfo";
    KycLevel[KycLevel["PhotoIdNoFm"] = 3] = "PhotoIdNoFm";
    KycLevel[KycLevel["PhotoIdFm"] = 4] = "PhotoIdFm";
})(KycLevel || (exports.KycLevel = KycLevel = {}));
var FeeType;
(function (FeeType) {
    FeeType[FeeType["PerOrder"] = 0] = "PerOrder";
    FeeType[FeeType["PerOrderItem"] = 1] = "PerOrderItem";
    FeeType[FeeType["PerTicket"] = 2] = "PerTicket";
})(FeeType || (exports.FeeType = FeeType = {}));
// #endregion
// #region User
var Roles;
(function (Roles) {
    Roles[Roles["User"] = 0] = "User";
    Roles[Roles["OnSiteSales"] = 1] = "OnSiteSales";
    Roles[Roles["HostOrganizer"] = 2] = "HostOrganizer";
    Roles[Roles["HostManager"] = 3] = "HostManager";
    Roles[Roles["Admin"] = 4] = "Admin";
    Roles[Roles["Custom"] = 5] = "Custom";
})(Roles || (exports.Roles = Roles = {}));
var MarketControlStatus;
(function (MarketControlStatus) {
    MarketControlStatus["Draft"] = "draft";
    MarketControlStatus["Published"] = "published";
    MarketControlStatus["Updated"] = "updated";
})(MarketControlStatus || (exports.MarketControlStatus = MarketControlStatus = {}));
//# sourceMappingURL=types.js.map